import { Button, Form } from 'react-bootstrap';
import { I18n } from '@/i18n/I18n';
import { MIN_ZOOM, MAX_ZOOM, ZOOM_STEP } from './constants';

export interface ZoomPanControlsProps {
  xZoom: number;
  xPan: number;
  yZoom: number;
  yPan: number;
  onXZoomChange: (value: number) => void;
  onXPanChange: (value: number) => void;
  onYZoomChange: (value: number) => void;
  onYPanChange: (value: number) => void;
  onReset: () => void;
}

export function ZoomPanControls({
  xZoom,
  xPan,
  yZoom,
  yPan,
  onXZoomChange,
  onXPanChange,
  onYZoomChange,
  onYPanChange,
  onReset
}: ZoomPanControlsProps) {
  return (
    <div className="mb-3 p-3 border rounded">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h6 className="mb-0">{I18n.get('graphZoomControls')}</h6>
        <Button
          variant="light"
          size="sm"
          onClick={onReset}
          aria-label={I18n.get('graphResetView')}
        >
          {I18n.get('graphResetView')}
        </Button>
      </div>
      <div className="row g-3">
        <div className="col-md-6">
          <Form.Group>
            <Form.Label className="small" aria-label={I18n.get('graphXZoom')}>
              {I18n.get('graphXZoom')}: {xZoom.toFixed(2)}
            </Form.Label>
            <Form.Range
              min={MIN_ZOOM}
              max={MAX_ZOOM}
              step={ZOOM_STEP}
              value={xZoom}
              onChange={(e) => onXZoomChange(parseFloat(e.target.value))}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label className="small" aria-label={I18n.get('graphXPan')}>
              {I18n.get('graphXPan')}: {xPan.toFixed(2)}
            </Form.Label>
            <Form.Range
              min="-1"
              max="1"
              step="0.01"
              value={xPan}
              onChange={(e) => onXPanChange(parseFloat(e.target.value))}
            />
          </Form.Group>
        </div>
        <div className="col-md-6">
          <Form.Group>
            <Form.Label className="small" aria-label={I18n.get('graphYZoom')}>
              {I18n.get('graphYZoom')}: {yZoom.toFixed(2)}
            </Form.Label>
            <Form.Range
              min={MIN_ZOOM}
              max={MAX_ZOOM}
              step={ZOOM_STEP}
              value={yZoom}
              onChange={(e) => onYZoomChange(parseFloat(e.target.value))}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label className="small" aria-label={I18n.get('graphYPan')}>
              {I18n.get('graphYPan')}: {yPan.toFixed(2)}
            </Form.Label>
            <Form.Range
              min="-1"
              max="1"
              step="0.01"
              value={yPan}
              onChange={(e) => onYPanChange(parseFloat(e.target.value))}
            />
          </Form.Group>
        </div>
      </div>
    </div>
  );
}

